import { Routes, RouterModule } from '@angular/router';

export const full: Routes = [

]